<template>
  <v-app>
    <section class="loginpage-wrapper clear">
      <div class="login-form-wrapper">
        <div class="login-form-box">
          <div class="login-logo"></div>
          <div class="login-wrapper">
            <div class="hogans-alerts">
              <v-alert
                :value="loginError"
                type="warning"
                transition="scale-transition"
              >
                Inloggegevens onjuist
              </v-alert>
            </div>
            <div class="hogans-alerts">
              <v-alert
                v-if="feedback"
                :value="feedback"
                type="warning"
                transition="scale-transition"
              >
                {{ feedback }}
              </v-alert>
              <v-alert
                v-if="success"
                :value="success"
                type="success"
                transition="scale-transition"
              >
                {{ success }}
              </v-alert>
            </div>
            <div id="login-form">
              <v-form
                ref="loginForm"
                lazy-validation
                @keyup.native.enter="submit()"
              >
                <v-text-field
                  label="Email"
                  v-model.trim="login.email"
                  :rules="emailRules"
                  autocomplete
                  prepend-icon="email"
                ></v-text-field>
                <v-text-field
                  label="Password"
                  v-model.trim="login.password"
                  :rules="passwordRules"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  prepend-icon="lock"
                  required
                ></v-text-field>

                <v-btn
                  class="login-button"
                  block
                  color="primary"
                  @click="submit"
                  >Login</v-btn
                >
                <div class="login-remember">
                  <v-checkbox
                    v-model="login.remember"
                    label="Remember me"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </div>

                <div class="login-forgot-password">
                  <a @click="resetPassword()">Wachtwoord vergeten</a>
                </div>
              </v-form>
            </div>
          </div>
          <!-- <div class="login-new-client clear">
            <div class="new-client-text">
              <p>Nog geen account?</p>
            </div>
            <div class="new-client-button">
              <v-btn block outline color="secondary" >Probeer gratis</v-btn>
            </div>
          </div> -->
        </div>
        <p class="login-disclaimer">
          &copy; {{ year }} Hogans. All rights reserved.
          <a href="#" target="_blank">Privacy Policy</a>
        </p>
      </div>
      <div class="login-image-wrapper"></div>
    </section>
  </v-app>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../firebase/init";
import moment from "moment";
import platform from "platform";

export default {
  name: "Login",
  props: ["destination"],
  data() {
    return {
      showPassword: false,
      login: {
        email: "",
        password: "",
        remember: true,
      },
      year: null,
      errors: [],
      feedback: null,
      success: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      passwordRules: [(v) => !!v || "Password is required"],
    };
  },

  created() {
    this.year = moment().format("YYYY");
  },

  methods: {
    resetPassword() {
      if (this.login.email) {
        firebase
          .auth()
          .sendPasswordResetEmail(this.login.email)
          .then(() => {
            this.feedback = null;
            this.success = "Email met instructies is verzonden";
            // Email sent.
          })
          .catch((error) => {
            this.feedback = "Er is iets misgegaan. Probeer het opnieuw";
          });
      } else {
        this.feedback = "Vul een emailadres in.";
      }
    },
    submit() {
      if (this.login.email && this.login.password) {
        const loginData = {
          email: this.login.email,
          password: this.login.password,
          remember: this.login.remember,
          returnSecureToken: true,
          destination: this.destination,
          software: String(platform.os),
          browser: platform.name + " " + platform.version,
          pillarrrVersion: this.$store.state.version,
        };
        this.feedback = null;
        this.$store.dispatch("login", loginData);
      } else {
        this.feedback = "Vul alle velden in.";
      }
    },
  },
  computed: {
    loginError() {
      return this.$store.state.error;
    },
    userId() {
      return this.$store.state.userId;
    },
    authenticated() {
      return this.$store.state.authenticated;
    },
  },
};
</script>
<style>
.loginpage-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}

.login-form-wrapper {
  position: absolute;
  background-color: #f6f7fb;
  height: 100%;
  width: 50%;
  top: 0;
  left: 0;
}

.login-image-wrapper {
  position: absolute;
  background: #e8e9ee url("../assets/pillar-login-image.png") no-repeat center
    center;
  background-size: cover;
  height: 100%;
  width: 50%;
  top: 0;
  right: 0;
}

.login-form-box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 380px;
  height: 560px;
  margin: -280px 0 0 -190px;
}

.login-wrapper {
  width: 380px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px #e8e9ee solid;
  border-radius: 5px;
  overflow: hidden;
}

#login-form {
  padding: 20px;
}

.login-logo {
  height: 100px;
  width: 300px;
  margin: 0 auto 30px auto;
}

.login-forgot-password {
  margin: 10px 0 0 0;
  border-top: 1px #e8e9ee solid;
  width: 100%;
}

.login-forgot-password a {
  text-decoration: none;
  padding: 10px 0;
  display: block;
  color: #8b93a6;
}

.login-new-client {
  width: 80%;
  margin: 20px auto 0 auto;
}

.new-client-text,
.new-client-button {
  width: 50%;
  float: left;
}

.new-client-text p {
  font-size: 14px;
  color: #373737;
  text-align: right;
  padding: 14px 15px 0 0;
}

.login-remember {
  padding: 5px 0 0 0;
}

.login-remember .v-input label {
  padding: 2px 0 0 0;
  font-size: 13px;
}

.login-disclaimer {
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
  display: block;
  font-size: 12px;
  color: #666666;
}

.login-disclaimer a {
  text-decoration: none;
}

@media only screen and (max-width: 800px) {
  .login-form-wrapper {
    width: 100%;
  }

  .login-image-wrapper {
    display: none;
  }
}

@media only screen and (max-width: 400px) {
  #login-form {
    width: 300px;
    height: 320px;
    padding: 15px;
  }

  .login-logo {
    height: 50px;
    width: 200px;
    margin: 0 auto 20px auto;
  }

  .new-client-text p {
    text-align: center;
    padding: 0;
  }

  .login-new-client {
    width: 60%;
  }

  .new-client-text,
  .new-client-button {
    width: 100%;
  }
}
</style>
